import React from 'react'
import PropTypes from 'prop-types'

import ListingDetailRatings from 'syft-acp-core/entities/ListingRatings/ListingRatings'

const ListingRatings = ({ match: { params } }) => (
  <ListingDetailRatings
    id={Number(params.id)}
    jobID={params.jobID ? Number(params.jobID) : 0}
    shiftID={params.shiftID ? Number(params.shiftID) : 0}
  />
)

ListingRatings.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }),
}

export default ListingRatings
